import { Register } from './Register';

import './styles.scss'

export default {
  Register
}